<script>
import mixinComponent from '../Mixins/mixinComponent'
import { globalVariablesMixin } from '../Mixins/global'
import { JSONError } from '../../../Errors/JsonError'
import ButtonAll from '../Components/UI/Button/ButtonAll.vue'
import Loader from '../Components/UI/Loading/Loader.vue'
import BlockContent from '../Components/UI/Content/BlockContent.vue'
import FormCreator from '../Components/UI/Form/FormCreator.vue'
import FieldCreator from '../Components/UI/Form/FieldCreator.vue'
import DocumentList from '../Components/Document/DocumentList.vue'
import ContractSignatureAlert from '../Components/Contract/ContractSignatureAlert.vue'
import { ContractSignatureError } from '../../../Errors/ContractSignatureError'

export default {
  components: { ContractSignatureAlert, DocumentList, FieldCreator, FormCreator, BlockContent, Loader, ButtonAll },

  mixins: [mixinComponent, globalVariablesMixin],

  data() {
    let urlParams = new URLSearchParams(window.location.search)
    return {
      contractId: 0,
      documentSignerId: null,
      token: urlParams.get('token'),
      def: {},
      documentSigner: {},
      formData: null,
      loadField: false,
      user: null,
      url: null,
      check: false,
      visible: false,
      ribok: false,
      uuid: false,
      sending: false,
      hideSignFieldReason: null,
      signError: null,
      documentLoaded: false,
      availableDocuments: [],
      missingDocuments: [],
    }
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    globalBuild({ build }) {
      this.loadField = build
    },
    async getUrl() {
      if (this.url) {
        window.location.href = this.url
      } else {
        const documentSign = await this.getJSON(`documentsigns/${this.documentSignerId}/urls/${this.token}`)

        if (documentSign) {
          window.location.href = documentSign.url
        }
      }
    },
    async download(documentSignerId, token, uuid) {
      await this.downloadFile(`documentsigns/${documentSignerId}/${token}/${uuid}/download/`, 'Contrat.pdf')
    },
    async sendSign() {
      try {
        this.sending = true

        if (this.check) {
          await this.patchJSON(`documentsigns/${this.documentSignerId}/${this.token}`, this.formData.datas, {})
        }

        await this.getUrl()
      } catch (e) {
        alert(e instanceof JSONError ? e.message : e)
      } finally {
        this.sending = false
      }
    },
    handleDocumentLoaded({ documents, missings }) {
      this.availableDocuments = documents
      this.missingDocuments = missings
      this.documentLoaded = true
    },
    async refreshDocumentList() {
      await this.getJSON(`documentsigns/${this.documentSignerId}/def/${this.token}`).then(
        (json) => {
          this.visible = true
          this.user = json.documentSigner
          this.url = json.url
          this.check = json.check
          this.ribok = json.ribok
          this.contractId = json.contractId
          if (this.contractId === 0) {
            this.documentLoaded = true
          }

          if (this.availableDocuments.length > 0) {
            this.ribok = this.availableDocuments.some((doc) => doc.code === 'rib' && doc.document.status !== 'REFUSED')
          }

          this.uuid = json.uuid

          if (this.check) {
            this.def = json.config
            this.documentSigner = json.documentSigner
          }

          if (['SIGNED', 'SIGNED_FULL'].includes(json.documentSigner.status)) {
            this.signError = new ContractSignatureError(this.$t('esign.alreadySigned'), 'esign.alreadySigned')
          }
        },
        (reason) => {
          this.documentLoaded = true
          const error = reason?.response?.error
          const errorCode = reason?.response?.code

          if (reason.statusCode === 400) {
            this.signError = new ContractSignatureError(this.$t(errorCode), errorCode)
          } else if (reason.statusCode === 404) {
            this.signError = new ContractSignatureError(this.$t('esign.notFound'), 'esign.notFound')
          } else if (!!error) {
            this.hideSignFieldReason = this.$t(error)
          } else {
            this.hideSignFieldReason = null
          }
        },
      )
    },
  },
  async beforeMount() {
    this.contractId = this.getContractId
    this.token = this.getToken
    this.documentSignerId = this.getSignerId

    if (this.documentSignerId === '' || this.token === '') {
      window.location = '/'
    }

    await this.$nextTick()
    await this.refreshDocumentList()
  },
  computed: {
    getUrlWithoutHashtag() {
      return window.location.href.split('#')[0]
    },
    getContractId() {
      let fullUrl = this.getUrlWithoutHashtag
      if (fullUrl.match(/\/contract\//)) {
        return fullUrl.match(/\/contract\/(\d+)\//)[1]
      }

      return 0
    },
    getToken() {
      let fullUrl = this.getUrlWithoutHashtag
      if (fullUrl.match(/\/cosigntoken\/(\d+)\/([^/?]+)/)) {
        return fullUrl.match(/\/cosigntoken\/(\d+)\/([^/?]+)/)[2]
      }

      let urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('token')
    },
    getSignerId() {
      let fullUrl = this.getUrlWithoutHashtag

      let id = null
      if (fullUrl.match(/\/cosigntoken\//)) {
        id = fullUrl.match(/\/cosigntoken\/(\d+)\//)[1]
      }

      if (fullUrl.match(/\/sign\//)) {
        id = fullUrl.match(/\/sign\/(\d+)\?/)[1]
      }

      return id
    },
    isValidationMode() {
      const queryParameters = new URLSearchParams(window.location.search)

      return '1' === queryParameters.get('validation')
    },
    ribDocument() {
      return this.availableDocuments.find(({ code }) => code === 'rib')
    },
    ribAvailable() {
      return this.ribDocument !== null
    },
    ribRejected() {
      return this.ribDocument?.document.statusCheck === 'ERROR'
    },
    signable() {
      return this.documentLoaded && (this.contractId === 0 || this.ribok === true) && !this.signError
    },
    hasMissingDocuments() {
      return this.missingDocuments.length > 0
    },
    hasError() {
      return !this.ribAvailable || this.ribRejected || !!this.hideSignFieldReason
    },
    pageTitle() {
      return this.$t(this.isValidationMode ? 'esign.validationTitle' : 'esign.signatureTitle')
    },
  },
}
</script>
<template>
  <main class="main-container">
    <div class="row">
      <div class="col-md-12 text-center">
        <div id="image_logo" title="<?php echo COMPANY; ?>"></div>
      </div>
      <div class="col-md-12">
        <h1 class="text-center font-weight-bold">
          {{ pageTitle }}
        </h1>
      </div>
    </div>
    <div class="row w-100" v-if="user && contractId !== 0 && documentLoaded && !signable && !signError">
      <div class="mx-auto">
        <ButtonAll
          type="validation"
          width="full"
          label="esign.viewContract"
          @click="download(documentSignerId, token, uuid)"
        />
      </div>
    </div>
    <div class="row justify-content-md-center">
      <Loader v-if="!documentLoaded" class="col-md-12"></Loader>

      <div :class="{ 'col-md-6': true, 'd-none': conf.docSignPage === false || (!hasMissingDocuments && !hasError) }">
        <BlockContent title-t="contract.document.documents" v-if="user && contractId !== 0">
          <div v-if="documentLoaded && hasError">
            <div v-if="contractId !== 0 && ribRejected" class="alert alert-warning">
              <strong>{{ $t('esign.ribError') }}</strong>
            </div>

            <div v-if="!!hideSignFieldReason" class="alert alert-warning">
              <strong>{{ hideSignFieldReason }}</strong>
            </div>
          </div>

          <DocumentList
            ref="signatureDocument"
            context="Contract"
            :context-id="contractId"
            :uuid="uuid"
            :missing-and-accept-only="['rib']"
            @document-loaded="handleDocumentLoaded"
            @document-uploaded="refreshDocumentList"
          />
        </BlockContent>
      </div>

      <div :class="{ 'd-none': !signable }" class="col-md-6">
        <br />
        <div class="mx-2">
          <FormCreator
            v-if="check"
            ref="formSignature"
            :config-def="def"
            :config-object="documentSigner"
            dynamic
            class-to-add="d-none"
            @update-data="updateData"
            @global-build="globalBuild"
          />

          <FieldCreator
            v-if="loadField"
            :form-data="formData"
            name="firstname"
            form-ref="formSignature"
            domain="sign"
            label-top
          />

          <FieldCreator
            v-if="loadField"
            :form-data="formData"
            name="lastname"
            form-ref="formSignature"
            domain="sign"
            label-top
          />

          <FieldCreator
            v-if="loadField"
            :form-data="formData"
            name="email"
            form-ref="formSignature"
            domain="sign"
            label-top
          />

          <FieldCreator
            v-if="loadField"
            :form-data="formData"
            name="phone"
            form-ref="formSignature"
            domain="sign"
            label-top
          />

          <p v-html="$t('esign.cgu', { urlcgu: config.conf.urlcgu, urlrgpd: config.conf.urlrgpd })"></p>
          <br />

          <ButtonAll type="validation" width="full" :loading="sending" label="button.confirm" @click="sendSign" />
        </div>
      </div>
      <div v-if="signError" class="col-md-6">
        <ContractSignatureAlert :error="signError" />
      </div>
    </div>
  </main>
</template>
